export const dashboardKo = {
  // 공유 — DashboardNav
  'dashboard.nav.ariaLabel': '대시보드 섹션',
  'dashboard.nav.overview': '개요',
  'dashboard.nav.avatar': '아바타',
  'dashboard.nav.coins': '동전',
  'dashboard.nav.contributions': '기여',

  // 공유 — StatusBadge (기여 상태)
  'dashboard.status.draft': '초안',
  'dashboard.status.submitted': '제출됨',
  'dashboard.status.communityReview': '커뮤니티 검토',
  'dashboard.status.officialReview': '공식 검토',
  'dashboard.status.approved': '승인됨',
  'dashboard.status.rejected': '거절됨',
  'dashboard.status.unknown': '알 수 없음',

  // 공유 — ClaimStatusBadge
  'dashboard.claimStatus.pending': '대기 중',
  'dashboard.claimStatus.approved': '승인됨',
  'dashboard.claimStatus.rejected': '거절됨',

  // DashboardPage
  'dashboard.seo.title': 'My Grymwyrd',
  'dashboard.seo.description': 'Grymwyrd의 영원한 황혼 속에서 당신의 동전, 신청, 기여, 그리고 캐릭터들.',
  'dashboard.displayNameFallback': '방랑자',
  'dashboard.welcomeBack': '돌아오셨습니다',
  'dashboard.editAvatar': '아바타 수정',
  'dashboard.loading': '당신의 전설을 모으는 중…',
  'dashboard.avatarAlt': '{name}의 초상화',
  'dashboard.offlineNotice':
    '라이브 프로필 데이터를 사용할 수 없습니다 — 마지막으로 알려진 세션과 샘플 콘텐츠를 표시합니다.',

  // DashboardPage — Coins card
  'dashboard.coins.title': 'Grave Coins',
  'dashboard.coins.viewAll': '모두 보기',
  'dashboard.coins.unit': '동전',
  'dashboard.coins.noActivity': '아직 동전 활동이 없습니다.',
  'dashboard.coins.fullHistory': '전체 기록 및 동전 구매',

  // DashboardPage — Contributions card
  'dashboard.contributions.title': '기여',
  'dashboard.contributions.manage': '관리',
  'dashboard.contributions.empty': '아직 기여가 없습니다 — 첫 번째를 작성하세요.',

  // DashboardPage — Claims card
  'dashboard.claims.title': 'Grymwyrd의 점령된 지역',
  'dashboard.claims.empty': 'Grymwyrd에서 아직 점령한 땅이 없습니다.',
  'dashboard.claims.kindClaimed': '{kind} · {date}에 점령됨',

  // DashboardPage — Characters card
  'dashboard.characters.title': '캐릭터',
  'dashboard.characters.empty': '당신의 이름에 묶인 영혼이 없습니다.',
  'dashboard.characters.level': 'Lv {level}',
  'dashboard.characters.unknown': '알 수 없음',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': '아바타 에디터',
  'dashboard.avatarEditor.seo.description': 'Grymwyrd 세계에 보여줄 얼굴을 만들어보세요.',
  'dashboard.avatarEditor.heading': '아바타 에디터',
  'dashboard.avatarEditor.errorNotImage': '해당 파일은 이미지가 아닙니다.',
  'dashboard.avatarEditor.errorNameRequired': '어둠 속에서도 이름은 필요합니다.',
  'dashboard.avatarEditor.portrait': '초상화',
  'dashboard.avatarEditor.portraitPreview': '초상화 미리보기',
  'dashboard.avatarEditor.avatarPreviewAlt': '아바타 미리보기',
  'dashboard.avatarEditor.zoom': '확대/축소',
  'dashboard.avatarEditor.zoomAria': '초상화 확대',
  'dashboard.avatarEditor.panHorizontal': '초상화를 가로로 이동',
  'dashboard.avatarEditor.panVertical': '초상화를 세로로 이동',
  'dashboard.avatarEditor.uploadAria': '초상화 이미지 업로드',
  'dashboard.avatarEditor.changeImage': '이미지 변경',
  'dashboard.avatarEditor.uploadImage': '이미지 업로드',
  'dashboard.avatarEditor.identity': '정체성',
  'dashboard.avatarEditor.displayName': '표시 이름',
  'dashboard.avatarEditor.backstory': '배경 이야기',
  'dashboard.avatarEditor.backstoryPlaceholder': '당신은 어디서 왔고, 어떤 어두운 운명을 추구합니까?',
  'dashboard.avatarEditor.publicProfile': '공개 프로필',
  'dashboard.avatarEditor.publicVisible': '전설의 전당에서 볼 수 있습니다.',
  'dashboard.avatarEditor.publicHidden': '다른 방랑자들로부터 숨겨집니다.',
  'dashboard.avatarEditor.saving': '저장 중…',
  'dashboard.avatarEditor.saveChanges': '변경 사항 저장',
  'dashboard.avatarEditor.saved': '저장됨',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': '아직 결제를 사용할 수 없습니다 — 금고가 닫혀 있습니다.',
  'dashboard.coinHistory.notEnoughCoins': '그를 위한 동전이 충분하지 않습니다.',
  'dashboard.coinHistory.reasonWorldClaim': '세계 점령',
  'dashboard.coinHistory.reasonCosmetic': '미용 항목',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': '{name}에 {cost}개의 동전을 사용했습니다.',
  'dashboard.coinHistory.seo.title': 'Grave Coins',
  'dashboard.coinHistory.seo.description': '당신의 전체 동전 장부, 충전, 그리고 죽은 자들의 상품.',
  'dashboard.coinHistory.heading': 'Grave Coins',
  'dashboard.coinHistory.balance': '잔액',
  'dashboard.coinHistory.buyCoins': '동전 구매',
  'dashboard.coinHistory.packCoins': '{coins}개의 동전',
  'dashboard.coinHistory.packBonus': ' + {bonus}개 보너스',
  'dashboard.coinHistory.summoningCheckout': '결제 소환 중…',
  'dashboard.coinHistory.purchase': '구매',
  'dashboard.coinHistory.spendCoins': '동전 사용',
  'dashboard.coinHistory.insufficientCoins': '동전 부족',
  'dashboard.coinHistory.spending': '사용 중…',
  'dashboard.coinHistory.spendAmount': '{cost}개 사용',
  'dashboard.coinHistory.historyTitle': '기록',
  'dashboard.coinHistory.tallyingLedger': '장부를 정산하는 중…',
  'dashboard.coinHistory.tableCaption': '동전 거래 기록',
  'dashboard.coinHistory.colReason': '사유',
  'dashboard.coinHistory.colAmount': '금액',
  'dashboard.coinHistory.noTransactions': '아직 거래가 없습니다.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': '내 기여',
  'dashboard.contributionsPage.seo.description':
    '당신이 작성한 로어와 검수자들의 검토를 거친 그 여정.',
  'dashboard.contributionsPage.heading': '기여',
  'dashboard.contributionsPage.newContribution': '새 기여',
  'dashboard.contributionsPage.loading': '당신의 두루마리를 펼치는 중…',
  'dashboard.contributionsPage.empty': '아직 로어를 작성하지 않았습니다. 첫 번째 기여를 시작하세요.',
  'dashboard.contributionsPage.untitledDraft': '제목 없는 초안',
  'dashboard.contributionsPage.moderator': '검수자:',
  'dashboard.contributionsPage.entryFallback': '항목',
  'dashboard.contributionsPage.errorNameRequired': '모든 창작물에는 이름이 필요합니다.',
  'dashboard.contributionsPage.modalTitle': '새 기여',
  'dashboard.contributionsPage.type': '종류',
  'dashboard.contributionsPage.titleLabel': '제목',
  'dashboard.contributionsPage.summaryLabel': '요약',
  'dashboard.contributionsPage.saveDraft': '초안 저장',
  'dashboard.contributionsPage.submitting': '제출 중…',
  'dashboard.contributionsPage.submitForReview': '검토를 위해 제출',
}
